export default __webpack_public_path__ + "src/images/packages/palms-on-the-rocks/212cc7477ab28c69ddbcf680181741e8-4.jpg";